export default __webpack_public_path__ + "static/media/news1.7923c389.jpg";